import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { SaleOrderParameterService } from '../proxy/controlling/controllers/sale-order-parameter.service';

FieldBuilder.setNamespace('Controlling');

export const SALEORDERPARAMETERVALUE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.SaleOrderParameterValue.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .text('value', 'Entity.SaleOrderParameterValue.Value')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder.foreignKey(
    'saleOrderParameterId',
    'Entity.SaleOrderParameter',
    SaleOrderParameterService
  )
    .required()
    .displayFromNested('saleOrderParameter.name')
    .sortBy('saleOrderParameter.name')
    .build(),
];

export const SALEORDERPARAMETERVALUE_CONFIG = {
  entityName: 'SaleOrderParameterValue',
  localizationKey: 'Controlling::Entity.SaleOrderParameterValue',
  fields: SALEORDERPARAMETERVALUE_FIELDS,
  permission: 'ControllingLiquidations.SaleOrderParameterValues',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Liquidations + MENU_NAME_SUFFIX,
};
